import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgModel,
  ValidationErrors,
  Validator
} from "@angular/forms";
import {NgbDateAdapter, NgbDateStruct, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {ACCEPT_DATE_FORMAT, ISODATE_FORMAT} from "./date-format";
import {GtNgDatepickerMaskDirective} from './gt-ng-datepicker-mask.directive';
import {NgClass} from '@angular/common';

@Component({
  selector: 'gt-ng-datepicker',
  templateUrl: './gt-ng-datepicker.component.html',
  styleUrls: ['./gt-ng-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GtNgDatepickerComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GtNgDatepickerComponent),
      multi: true
    }
    // {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ],
  imports: [
    GtNgDatepickerMaskDirective,
    FormsModule,
    NgbInputDatepicker,
    NgClass
  ]
})
export class GtNgDatepickerComponent implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor, Validator {
  value: string;
  correctFormat: boolean = true;
  isFocused = false;
  @Input() hasTime: boolean = false;
  @Input() id: string;
  @Input() name: string;
  @Input() minDate: NgbDateStruct;
  @Input() maxDate: NgbDateStruct;
  @Input() disabled: boolean = false;
  @Input() markDisabled = false;
  @Input() required: boolean = false;
  @Output() valueOnchange = new EventEmitter();
  @Output() focus = new EventEmitter<FocusEvent>();
  @Output() blur = new EventEmitter<FocusEvent>();
  @ViewChild("datepicker", {static: true})
  datepicker: ElementRef;
  private readonly adapter: NgbDateAdapter<string> = inject(NgbDateAdapter);
  @Input() inputSize: 'sm' | 'md' = 'md';

  onChange = (value) => {
  };
  onTouched = () => {
  };
  onValidatorChange = () => {
  };

  constructor(private readonly cdr: ChangeDetectorRef, private readonly renderer: Renderer2) {

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  writeValue(value: string) {
    if (value) {
      if (ISODATE_FORMAT.test(value)) {
        const dateParts = value.split('-');
        if (dateParts.length === 3) {
          // model is stored in CE (ค.ศ.); show the input to the user in BE (พ.ศ.)
          this.value = `${dateParts[2]}/${dateParts[1]}/${Number(dateParts[0]) + 543}`;
        } else {
          this.value = value;
        }
      } else {
        this.value = value;
      }
    } else {
      this.value = undefined;
    }
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  valueChange(value: string, dateModel?: NgModel) {
    this.correctFormat = true;
    if (this.value && this.value.trim() !== undefined) {
      if (ACCEPT_DATE_FORMAT.test(this.value)) {
        const value: string[] = this.value.split('/');
        // user types BE (พ.ศ.); convert back to CE (ค.ศ.) for the model
        this.value = `${Number(value[2]) - 543}-${value[1]}-${value[0]}`;
      } else if (ISODATE_FORMAT.test(this.value)) {
        const T = this.value.indexOf('T');
        if (T !== -1) {
          this.value = this.value.split('T')[0];
        }
      } else {
        this.correctFormat = false;
      }
    } else {
      this.value = undefined;
    }
    this.onChange(this.value);
    if (this.isFocused) {
      this.onTouched();
    }
  }

  onFocus(event: FocusEvent): void {
    this.isFocused = true;
    this.focus.emit(event);
  }

  onBlur(event: FocusEvent): void {
    this.isFocused = false;
    this.onTouched();
    this.blur.emit(event);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.required && !this.value) {
      return {required: true};
    }
    if (!this.correctFormat) {
      return {invalidDate: true};
    }
    return null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['required'] || changes['minLength']) {
      if (this.onValidatorChange) {
        this.onValidatorChange();
      }
    }
  }

  ngOnDestroy(): void {
  }

  @Input()
  set minDateString(minDate: string) {
    if (minDate) {
      this.minDate = this.adapter.fromModel(minDate);
    } else {
      this.minDate = undefined;
    }
  }

  @Input()
  set maxDateString(maxDate: string) {
    if (maxDate == 'today') {
      let today = new Date();
      this.maxDate = this.adapter.fromModel(today.toISOString());
      return;
    }
    if (maxDate) {
      this.maxDate = this.adapter.fromModel(maxDate);
    } else {
      this.maxDate = undefined;
    }
  }
}
